export default "__VITE_ASSET__CcaH$oSS__"